import reducer from "./reducer";
export { default as IssueVacations } from "./components";
export { default as issueVacationsReducerName } from "./constants";
export default reducer;
